// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { AccountListProvider } from '../context/AccountListContext';
import SalesAccounts from '../components/Frontend/Accounts/SalesAccounts';

export const saleAccountsRoute = (
  <>
    <Route path="/sales_accounts" element={<MainLayout />}>
      <Route index element={
        <AccountListProvider>
          <SalesAccounts />
        </AccountListProvider>
      } />
    </Route>
  </>
);
